import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Login from './components/login/Login';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Signup from './components/signup/Signup';
import Dashboard from './components/dashboard/Dashboard';
import RequireAuth from './components/auth/RequireAuth';
import { AuthContextProvider } from './components/context/AuthContext';
import AddGiftForm from './components/gifts/AddGiftForm';
import RedirectPage from './components/redirect_page/RedirectPage';
import ProfilePage from './components/profile/ProfilePage';
import LoggedOut from './components/logged_out/LoggedOut';
import OauthLogin from './components/login/oauth_login/OauthLogin';
import VerifyEmail from './components/verify_email/VerifyEmail';
import About from './components/about/About';
import EventInfo from './components/events/EventInfo';
import DashOptions from './components/dash/DashOptions';
import AddEventForm from './components/events/AddEventForm';
import ResetPassword from './components/reset/ResetPassword';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthContextProvider>
  <Router>
    <Routes>
      <Route path="/" element={<App />}>
        <Route path="/" element={<Login />} />
        <Route path="/oauth" element={<OauthLogin />} />
        <Route path="/auth" element={<VerifyEmail />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/dashboard/addeventform" element={<RequireAuth><AddEventForm /></RequireAuth>} />
        <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="/dashboard/eventinfo/:event" element={<RequireAuth><EventInfo /></RequireAuth>} />
        <Route path="/dashboard/user/:profile" element={<RequireAuth><ProfilePage /></RequireAuth>} />
        <Route path="/dashboard/event/:id" element={<RequireAuth><AddGiftForm /></RequireAuth>} />
        <Route path="/departure" element={<LoggedOut />} />
        <Route path="/dashboard/about" element={<About />} />
        <Route path="*" element={<RedirectPage />} />
      </Route>
    </Routes>
  </Router>
  </AuthContextProvider>
);


